import React from 'react';
import { number } from 'prop-types';
import { Translate } from 'react-localize-redux';
import { useLocation, useParams } from 'react-router-dom';
import useTitle from '../../hooks/useTitle';
import { ERROR_TITLE } from '../../constants';

const getErrorCode = (location, params) => {
  if (params && params.errorCode) {
    return Number(params.errorCode);
  } if (location && location.state && location.state.errorCode) {
    return location.state.errorCode;
  }
  return 0;
};

const getErrorTranslationKey = (errorCode) => {
  switch (errorCode) {
    case 401:
    case 403: return 'errorPage.accessDeniedError';
    case 404: return 'errorPage.notFound';
    default: return 'errorPage.unknownError';
  }
};

const ErrorContainer = ({ errorCode }) => (
  <div><p><Translate id={getErrorTranslationKey(errorCode)} /></p></div>
);

const ErrorPage = () => {
  useTitle(ERROR_TITLE);
  const location = useLocation();
  const params = useParams();
  const errorCode = getErrorCode(location, params);
  return (
    <div className="page-container">
      <h1 className="page-title--small"><Translate id="errorPage.errorHappened" /></h1>
      <ErrorContainer errorCode={errorCode} />
    </div>
  );
};

ErrorContainer.propTypes = {
  errorCode: number.isRequired
};

export default ErrorPage;
